export const API_BASE_PATH = "/api";

// Keep in sync with the length validation on User#password.
export const PASSWORD_MIN_LENGTH = 8;
